<span class="overline">School</span>
<h3 class="mt-2">Contact Information</h3>
<!-- NONE EDIT MODE no Form -->
<ng-container *ngFor="let contact of schoolData">
  <div class="row border-bottom" *ngIf="!editModeOff">
    <div class="col">
      <span class="mb-4 overline">
        General Information
      </span>
      <app-divider></app-divider>
      <div class="data-list-item my-2">
        <div>
          Title
        </div>
        <div>
          <strong class="right-align">{{ contact?.title }}</strong>
        </div>
      </div>
      <app-divider></app-divider>
      <div class="data-list-item my-2">
        <div>
          Name
        </div>
        <div>
          <strong class="right-align"
            >{{ contact?.firstName }} {{ contact?.middleName }} {{ contact?.lastName }}</strong
          >
        </div>
      </div>
      <app-divider></app-divider>
      <div class="data-list-item my-2">
        <div>
          URL
        </div>
        <div>
          <strong class="right-align">{{ contact?.url }}</strong>
        </div>
      </div>
    </div>
    <div class="col">
      <span class="mb-4 overline">
        Phone Information
      </span>
      <app-divider></app-divider>
      <div class="data-list-item my-2" *ngFor="let phone of contact.phoneNumbers">
        <div *ngIf="phone.isPrimary === true">
          Primary Phone Number
        </div>
        <div *ngIf="phone.isPrimary === false">
          Alternate Phone Number
        </div>
        <div *ngIf="phone.phoneNumber.length > 10">
          <strong class="right-align">{{ phone.phoneNumber | mask: '+0 (000) 000-0000' }}</strong>
        </div>
        <div *ngIf="phone.phoneNumber.length === 10">
          <strong class="right-align">+1 {{ phone.phoneNumber | mask: '(000) 000-0000' }}</strong>
        </div>
      </div>
      <app-divider class="mb-4"></app-divider>
      <span class="mb-4 overline">
        Email Information
      </span>
      <app-divider></app-divider>
      <div class="data-list-item my-2" *ngFor="let email of contact.emailAddresses">
        <div *ngIf="email.isPrimary === true">
          Primary Email Address
        </div>
        <div *ngIf="email.isPrimary === false">
          Alternate Email Address
        </div>
        <div>
          <strong class="right-align">{{ email.emailAddress }}</strong>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- Edit Mode -->
<div *ngIf="editModeOff" [formGroup]="form">
  <div formArrayName="contacts">
    <div
      class="row border-bottom"
      *ngFor="let con of contacts().controls; let conIndex = index"
      formGroupName="{{ conIndex }}"
    >
      <div class="col">
        <span class="mb-4 overline">
          General Information
        </span>
        <app-divider class="mb-2"></app-divider>
        <mat-form-field>
          <mat-label>Title</mat-label>
          <input matInput type="text" placeholder="Title" formControlName="title" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>First Name</mat-label>
          <input matInput type="text" placeholder="First Name" formControlName="firstName" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Middle Name</mat-label>
          <input matInput type="text" placeholder="Middle Name" formControlName="middleName" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Last Name</mat-label>
          <input matInput type="text" placeholder="Last Name" formControlName="lastName" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>URL</mat-label>
          <input matInput type="text" placeholder="URL" formControlName="url" />
        </mat-form-field>
      </div>
      <div class="col">
        <span class="mb-4 overline">
          Phone Information
        </span>
        <app-divider class="mb-2"></app-divider>
        <!-- phone form area -->
        <div formArrayName="phoneNumbers" class="mb-4">
          <div *ngFor="let phoneNumber of phone(conIndex).controls; let phIndex = index" formGroupName="{{ phIndex }}">
            <div class="row">
              <div class="col-10">
                <mat-slide-toggle class="mx-3" color="accent" matTooltip="Primary Phone" formControlName="isPrimary">
                  <span class="mat-body-strong text-uppercase">Primary</span>
                </mat-slide-toggle>
                <strong>|</strong>
                <mat-slide-toggle class="mx-3" color="accent" matTooltip="Mobile Phone" formControlName="isMobile">
                  <span class="mat-body-strong text-uppercase">Mobile</span>
                </mat-slide-toggle>
                <mat-form-field>
                  <mat-label *ngIf="phIndex === 0">Primary Phone Number</mat-label>
                  <mat-label *ngIf="phIndex !== 0">Alternate Phone Number</mat-label>
                  <input
                    matInput
                    placeholder="Phone Number"
                    formControlName="phoneNumber"
                    [showMaskTyped]="true"
                    prefix="+1"
                    mask="(000) 000-0000"
                    type="text"
                  />
                </mat-form-field>
              </div>
              <div class="col">
                <button
                  class="no-btn-styles position-delete-icon"
                  (click)="removePhone(conIndex, phIndex)"
                  *ngIf="!phoneNumber.value.phoneNumber"
                >
                  <span class="material-icons info-icon">remove_circle</span>
                </button>
              </div>
            </div>
          </div>
          <button class="no-btn-styles" (click)="addPhoneNumber(conIndex)">
            <span class="material-icons info-icon">add_circle</span>Add Another Phone
          </button>
        </div>
        <span class="mb-4 overline">
          Email Information
        </span>
        <app-divider class="mb-2"></app-divider>
        <!-- email form area -->
        <div formArrayName="emailAddresses" class="mb-4">
          <div *ngFor="let emailAddress of email(conIndex).controls; let e = index" formGroupName="{{ e }}">
            <div class="row">
              <div class="col-10">
                <mat-slide-toggle class="mx-3" color="accent" matTooltip="Primary Email" formControlName="isPrimary">
                  <span class="mat-body-strong text-uppercase">Primary</span>
                </mat-slide-toggle>
                <mat-form-field>
                  <mat-label>Email Address</mat-label>
                  <input matInput type="text" placeholder="Email Address" formControlName="emailAddress" />
                </mat-form-field>
              </div>
              <div class="col">
                <button
                  class="no-btn-styles position-delete-icon"
                  (click)="removeEmail(conIndex, e)"
                  *ngIf="!emailAddress.value.emailAddress"
                >
                  <span class="material-icons info-icon">remove_circle</span>
                </button>
              </div>
            </div>
          </div>
          <button class="no-btn-styles" (click)="addEmail(conIndex)">
            <span class="material-icons info-icon">add_circle</span>Add Another Email
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row pad-bot-10">
  <div class="col d-flex justify-content-start">
    <button
      mat-stroked-button
      color="accent"
      *ngIf="!editModeOff"
      [disabled]="wrongUser"
      (click)="editForm()"
    >
      Edit
    </button>
    <button mat-raised-button color="primary" *ngIf="editModeOff" class="margin-right-10" (click)="cancelEdit()">
      Cancel Edit
    </button>
    <button
      mat-raised-button
      color="primary"
      type="submit"
      *ngIf="editModeOff"
      [disabled]="form.pristine || form.invalid"
      class="margin-right-10"
      (click)="submit()"
    >
      Save Changes
    </button>
    <button mat-stroked-button color="accent" *ngIf="editModeOff" [disabled]="form.pristine">
      Revert Changes
    </button>
  </div>
  <div class="col">
    <button mat-raised-button color="primary" *ngIf="editModeOff" class="margin-right-10" (click)="addContacts()">
      Add Contact
    </button>
  </div>
</div>
